import adidas from './Componentes/AssetsBanner/adidas.png';
import caixa from './Componentes/AssetsBanner/caixa.png';
import nissan from './Componentes/AssetsBanner/nissan.png';
import volkswagen from './Componentes/AssetsBanner/volkswagen.png';
import toyota from './Componentes/AssetsBanner/toyota.png';
import santander from './Componentes/AssetsBanner/santander.png';



const marcaData = [
{
    src: santander,
    title: 'logo santander', 
},
{
    src: caixa,
    title: 'logo caixa',
},
{
    src: adidas,
    title: 'logo adidas',
},
{
    src: nissan,
    title: 'logo nissan',
},
{
    src: volkswagen,
    title: 'logo volkswagen',
},
{
    src: toyota,
    title: 'logo toyota',
}
];

export default marcaData





